import { RouterView, type RouterOptions } from "vue-router";
// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  persons: "Person.Persons",
  list: "Person.PersonList",
  // personNew: "PersonNew",
  // personBase: "PersonBase",
  // personView: "PersonView",
  // personEdit: "PersonEdit",
};

export { names as personRouteNames };

const personRoutes: RouterOptions["routes"] = [
  {
    path: "/persons",
    name: names.persons,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Contacts" },
        component: () => import("@/views/person/PersonList.vue"),
      } /*,
      {
        path: "new",
        component: () => import("@/views/person/PersonBase.vue"),
        redirect: { name: names.personNew },
        props: true,
        children: [
          {
            path: "",
            name: names.personNew,
            meta: { title: "New Contact", isNew: true },
            component: () => import("@/views/person/PersonEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.personBase,
        component: () => import("@/views/person/PersonBase.vue"),
        redirect: { name: names.personView },
        children: [
          {
            path: "view",
            name: names.personView,
            meta: { title: "Contact View" },
            component: () => import("@/views/person/PersonView.vue"),
          },
          {
            path: "edit",
            name: names.personEdit,
            meta: { title: "Contact Edit", isForm: true },
            component: () => import("@/views/person/PersonEdit.vue"),
          },
        ],
      },*/,
    ],
  },
];
export default personRoutes;
